import { render, staticRenderFns } from "./TheFooter.vue?vue&type=template&id=ec620fce&scoped=true"
import script from "./TheFooter.vue?vue&type=script&lang=ts"
export * from "./TheFooter.vue?vue&type=script&lang=ts"
import style0 from "./TheFooter.vue?vue&type=style&index=0&id=ec620fce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec620fce",
  null
  
)

export default component.exports